<template>
  <div id="app">
    <vue-progress-bar></vue-progress-bar>

    <layout-header @showSearch="ev => (showSearch = ev)"> </layout-header>
    <router-view :key="keyPath"></router-view>
    <layout-footer v-if="showFoot"></layout-footer>
    <search v-if="showSearch" @close="showSearch = false"></search>
    <!-- <img
      src="./assets/images/ring.png"
      class="fixed-bottom"
      @mouseenter="openKefu"
    /> -->
  </div>
</template>

<script>
import LayoutHeader from './pages/layout/layout-header'
import LayoutFooter from './pages/layout/layout-footer'
import Search from './search'
export default {
  name: 'app',
  components: {
    LayoutFooter,
    LayoutHeader,
    Search
  },
  data() {
    return {
      showFoot: true,
      keyPath: '',
      showSearch: false
    }
  },
  watch: {
    /**
     *  
     *  val.name === 'works' ||
        val.name === 'contact-us' ||
        val.name === 'dynamics' ||
        val.name === 'team' ||
        val.name === 'company-promotion' ||
        val.name === 'welfare' ||
        val.name === 'coronavirus' ||
        val.name === 'certfication' ||
        val.name === 'contact-us' ||
        val.name === 'team-more' ||
        val.name === 'company-profile'
     */
    $route(val) {
      this.keyPath = val.fullPath
      if (
        val.name === 'works' ||
        val.name === 'team'
      ) {
        this.showFoot = false
      } else {
        this.showFoot = true
      }
    }
  },
  mounted() {
    //  [App.vue specific] When App.vue is finish loading finish the progress bar
    this.$Progress.finish()
  },
  created() {
    //  [App.vue specific] When App.vue is first loaded start the progress bar
    this.$Progress.start()
    //  hook the progress bar to start before we move router-view
    this.$router.beforeEach((to, from, next) => {
      //  does the page we want to go to have a meta.progress object
      if (to.meta.progress !== undefined) {
        let meta = to.meta.progress
        // parse meta tags
        this.$Progress.parseMeta(meta)
      }
      //  start the progress bar
      this.$Progress.start()
      //  continue to next page
      next()
    })
    //  hook the progress bar to finish after we've finished moving router-view
    this.$router.afterEach((to, from) => {
      //  finish the progress bar
      this.$Progress.finish()
    })
  },
  methods: {
    openKefu() {
      console.log('====opekefu')
      // window._LAIGU('withoutBtn')
      window._LAIGU('showPanel')
    }
  }
}
</script>

<style lang="postcss">
@import 'assets/styles/tailwind.css';
@import './index.css';

@keyframes fadeAndScale {
  from {
    /* transform: scale(0); */
    opacity: 0;
  }

  to {
    opacity: 1;
    /* transform: scale(1); */
  }
}

#app {
  min-width: 1200px;
  margin: auto;
  /* overflow: scroll; */
  min-height: 766px;
  animation: fadeAndScale 2s ease-in-out;
}

.fixed-bottom {
  position: fixed;
  z-index: 9999;
  right: 20px;
  bottom: 180px;
  width: 60px;
  height: 60px;
}
</style>
